import { render, staticRenderFns } from "./in-page-navigation.vue?vue&type=template&id=4985c0ee"
import script from "./in-page-navigation.vue?vue&type=script&lang=js"
export * from "./in-page-navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports